import React, { PureComponent } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

import TabEmail from '../../views/RecapArtisan/TabEmail';

class ReplyMailDialog extends PureComponent {
  render() {
    const { open, callback, defaultText } = this.props;
    return (
      <Dialog open={open} maxWidth="lg" fullWidth>
        <DialogTitle>Mail artisan</DialogTitle>
        <DialogContent dividers>
          {defaultText.artisanId ?
            <TabEmail artisanId={defaultText.artisanId} />
            : <Typography>Aucun mail trouvé</Typography>}
        </DialogContent>
        <DialogActions>
          <Button onClick={callback} color='secondary'>Fermer</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ReplyMailDialog;
